import React from 'react';
import styled from '@emotion/styled';
import { Only } from 'ui/components/elements/Only/Only';
import { mqMin } from 'utils/responsive';
import Img01 from 'ui/images/top_for_agent/topFunction_img01.svg';
import Img02 from 'ui/images/top_for_agent/topFunction_img02.svg';
import Img03 from 'ui/images/top_for_agent/topFunction_img03.svg';
import Img04 from 'ui/images/top_for_agent/topFunction_img04.svg';
import Img05 from 'ui/images/top_for_agent/topFunction_img05.svg';

const Section = styled.section`
    padding: 61px 0 58px 0;

    ${mqMin('NARROW')} {
        padding: 91px 0 106px 0;
    }
`;

const H2 = styled.h2`
    text-align: center;
    font-size: 1.625rem; /*26px*/
    letter-spacing: 0.1em;
    margin-bottom: 37px;

    ${mqMin('NARROW')} {
        font-size: 1.75rem; /*28px*/
        margin-bottom: 11px;
    }
`;

const Text = styled.p`
    text-align: center;
    line-height: 1.8em;
    letter-spacing: 0.1em;
    margin: 0 auto 47px auto;

    ${mqMin('NARROW')} {
        margin: 0 auto 61px auto;
    }
`;

const ListContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 93.02325581395349%;
    max-width: 400px;
    margin: 0 auto 0 auto;

    ${mqMin('SP')} {
        max-width: 750px;
    }

    ${mqMin('NARROW')} {
        max-width: 1050px;
    }
`;

const ListItem = styled.div`
    width: 49%;
    margin: 0 1% 36px 0;
    opacity: 0;
    transition: opacity 1s cubic-bezier(0.25, 1, 0.5, 1);
    opacity: 0;
    transform: translateY(30px);
    transition:
        transform 1s cubic-bezier(0.25, 1, 0.5, 1),
        opacity 1s cubic-bezier(0.25, 1, 0.5, 1);

    img {
        width: 143px;
        margin: 0 auto 12px auto;
    }

    h3 {
        font-size: min(4vw, 16px);
        text-align: center;
        line-height: 1.4em;
        letter-spacing: 0.1em;
    }

    ${mqMin('SP')} {
        width: 32%;
    }

    ${mqMin('NARROW')} {
        width: 19%;
        margin: 0 auto 36px auto;

        &:nth-child(even) {
            margin: 0 auto 36px auto;
        }

        img {
            margin: 0 auto 22px auto;
        }

        h3 {
            font-size: min(1.5vw, 18px);
        }
    }
`;

export const Function: React.FC = () => {
    return (
        <Section>
            <H2 className="fadein fadein_y">MAnyの機能</H2>
            <Text className="fadein fadein_y">
                メッセージから面談設定まで、
                <Only sp>
                    <br />
                </Only>
                やり取りはMAnyで全て完結。
            </Text>
            <ListContainer className="fadeinLi">
                <ListItem>
                    <div>
                        <img src={Img01} />
                    </div>
                    <h3>企業情報検索</h3>
                </ListItem>
                <ListItem>
                    <div>
                        <img src={Img02} />
                    </div>
                    <h3>
                        マッチングオファーの
                        <br />
                        送信・受信
                    </h3>
                </ListItem>
                <ListItem>
                    <div>
                        <img src={Img03} />
                    </div>
                    <h3>
                        ダイレクト
                        <br />
                        メッセージ
                    </h3>
                </ListItem>
                <ListItem>
                    <div>
                        <img src={Img04} />
                    </div>
                    <h3>
                        面談日時管理
                        <br />
                        カレンダー
                    </h3>
                </ListItem>
                <ListItem>
                    <div>
                        <img src={Img05} />
                    </div>
                    <h3>
                        請求書払い
                        <br />
                        対応
                    </h3>
                </ListItem>
            </ListContainer>
        </Section>
    );
};
